module.exports = __webpack_public_path__ + "img/Group 1037eight.104402fc.png";